import React, { useState, useEffect } from 'react';
import { Dropdown } from 'semantic-ui-react'
import ReadAxios from '../axiosComponent/read';

const MyCity = ({
    field: { name },
    form: { setFieldValue },
    ...props
}) => {
    const [content, setcontent] = useState([])
    const [loading, setloading] = useState(false)
    let handleSearch = (e, data) => {
        if (data.searchQuery) {
            setloading(true)
            let searchTerm = data.searchQuery
            ReadAxios({ url: 'cityMaster', readItems: { searchTerm: searchTerm } })
                .then((result) => {
                    console.log();
                    let city_master=[]
                    if(result.data?.resultSet?.length > 0){
                        city_master = result.data?.resultSet
                        if(props.stateFilterId){
                            city_master = city_master.filter((city)=> city.stateId === props.stateFilterId)
                        }
                    }
                    setcontent(city_master)
                    setloading(false)
                })
        }
    }
    let options = []
    if (content.length > 0) {
        content.map((object, index) => {
            let temp = {}
            temp.key = object.cityCode
            temp.text = object.cityName
            temp.value = props.citynameValue ? object.cityName : object.city_id
            temp.extra = object
            return options[index] = temp
        })
    }
    let handleChange = (value, data) => {
        setFieldValue(name, data.value)
        let extra = options.find((obj)=>obj.value === data.value)?.extra
        if(props.stateName){
            extra?.stateName ? setFieldValue(props.stateName, extra.stateName) : setFieldValue(props.stateName, "")
        }
        if(props.cityName){
            extra?.cityName && setFieldValue(props.cityName, extra.cityName)
        }
    }
    return (
        <Dropdown
            selection
            search
            loading={loading ? true : false}
            style={{ width: '100%' }}
            onChange={handleChange}
            options={options}
            // id="searchType"
            error={props.error}
            onSearchChange={handleSearch}
            noResultsMessage="Search for Result"
            {...props}
        />

    )
}

export default MyCity